import { FC } from 'react'
import { Lead } from '@/api/types/crm.types'
import PurchasesBlock from './PurchasesBlock'
import classes from './index.module.css'
import LinksPurchasesBlock from './LinksPurchasesBlock'
import { useAsyncRetry } from 'react-use'
import { classApi, directionOrdersApi } from '@/api'

interface WideShoppingContentProps {
  lead: Lead
}

const WideShoppingContent: FC<WideShoppingContentProps> = ({ lead }) => {
  // prettier-ignore
  const { value: excludedClassIds, retry: retryExcludedClassIds } = useAsyncRetry(
    async () => (lead.user_id && (await classApi.showByUser(lead.user_id))?.data?.data.map((c: { id: number }) => c?.id)) || [],
    [lead.user_id],
  )
  // prettier-ignore
  const { value: excludedDirectionIds, retry: retryExcludedDirectionIds } = useAsyncRetry(
    async () => (lead.user_id && (await directionOrdersApi.get({filter: [`[children_id][eq]=${lead.user_id}`], pageSize: false}))?.data?.data.map((c: { direction_id: number }) => c.direction_id)) || [],
    [lead.user_id],
  )

  return (
    <div className={classes.wrapper}>
      <PurchasesBlock
        lead={lead}
        excludedClassIds={excludedClassIds}
        excludedDirectionIds={excludedDirectionIds}
        refetchExcludedIds={() => {
          retryExcludedClassIds()
          retryExcludedDirectionIds()
        }}
      />
      <LinksPurchasesBlock
        lead={lead}
        excludedClassIds={excludedClassIds}
        excludedDirectionIds={excludedDirectionIds}
        refetchExcludedIds={() => {
          retryExcludedClassIds()
          retryExcludedDirectionIds()
        }}
      />
    </div>
  )
}

export default WideShoppingContent
